<div class="appointment-pill">
  @if (icon) {
    <ion-icon [name]="icon"></ion-icon>
  }
  <span class="content"><ng-content></ng-content></span>
  @if (showButtons) {
    <span class="time-button minus-button" (click)="handleDecrease()">-</span>
    <div class="time-button plus-button" (click)="handleIncrease()">
      <span class="plus-char">+</span>
    </div>
  }
</div>
